var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKycVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.75H6C5.86193 13.75 5.75 13.8619 5.75 14V16C5.75 16.1381 5.86193 16.25 6 16.25H8C8.13807 16.25 8.25 16.1381 8.25 16V14C8.25 13.8619 8.13807 13.75 8 13.75Z",
    fill: "url(#paint0_linear_79_2381)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 8.25V7C22.7489 6.00576 22.3535 5.05255 21.6505 4.34952C20.9475 3.64649 19.9942 3.25106 19 3.25H5C4.00576 3.25106 3.05255 3.64649 2.34952 4.34952C1.64649 5.05255 1.25106 6.00576 1.25 7V8.25H22.75Z",
    fill: "url(#paint1_linear_79_2381)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 9.75V17C1.25106 17.9942 1.64649 18.9474 2.34952 19.6505C3.05255 20.3535 4.00576 20.7489 5 20.75H19C19.9942 20.7489 20.9475 20.3535 21.6505 19.6505C22.3535 18.9474 22.7489 17.9942 22.75 17V9.75H1.25ZM9.75 16C9.74947 16.464 9.56493 16.9088 9.23685 17.2369C8.90878 17.5649 8.46397 17.7495 8 17.75H6C5.53603 17.7495 5.09122 17.5649 4.76315 17.2369C4.43507 16.9088 4.25053 16.464 4.25 16V14C4.25053 13.536 4.43507 13.0912 4.76315 12.7631C5.09122 12.4351 5.53603 12.2505 6 12.25H8C8.46397 12.2505 8.90878 12.4351 9.23685 12.7631C9.56493 13.0912 9.74947 13.536 9.75 14V16ZM14 17.75H12C11.8011 17.75 11.6103 17.671 11.4697 17.5303C11.329 17.3897 11.25 17.1989 11.25 17C11.25 16.8011 11.329 16.6103 11.4697 16.4697C11.6103 16.329 11.8011 16.25 12 16.25H14C14.1989 16.25 14.3897 16.329 14.5303 16.4697C14.671 16.6103 14.75 16.8011 14.75 17C14.75 17.1989 14.671 17.3897 14.5303 17.5303C14.3897 17.671 14.1989 17.75 14 17.75ZM19 17.75H17C16.8011 17.75 16.6103 17.671 16.4697 17.5303C16.329 17.3897 16.25 17.1989 16.25 17C16.25 16.8011 16.329 16.6103 16.4697 16.4697C16.6103 16.329 16.8011 16.25 17 16.25H19C19.1989 16.25 19.3897 16.329 19.5303 16.4697C19.671 16.6103 19.75 16.8011 19.75 17C19.75 17.1989 19.671 17.3897 19.5303 17.5303C19.3897 17.671 19.1989 17.75 19 17.75Z",
    fill: "#CABCFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_2381",
    x1: 8.25,
    y1: 15,
    x2: 5.75,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A631FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#896DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_2381",
    x1: 22.75,
    y1: 5.75,
    x2: 1.25,
    y2: 5.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A631FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#896DFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycVerification);
export default __webpack_public_path__ + "static/media/kyc-verification.4de4fa09423ca65469aae4b02cabb8ce.svg";
export { ForwardRef as ReactComponent };